import React from "react";
import { label } from "../../../config";
import "./FormAdminChipProperties.scss";

/**
 * Read-only notice for admin workflow chips and a Show/Hide toggle for the chip name label on the form.
 * @param {Object} props
 * @param {Object} props.selectedElement - Selected canvas element (user chip / user variable)
 * @param {function(string|number, Object): void} props.onFieldPropertiesChange - Updates element properties
 * @author Abhishek Dhillon
 * @component FormPropertiesWrapper
 */
const FormAdminChipProperties = ({ selectedElement, onFieldPropertiesChange }) => {
  const showChipName = selectedElement?.properties?.showChipName ?? true;

  return (
    <div className='form-admin-chip-properties'>
      <div className='text-truncate form-sub-heading mb-3 form-admin-chip-properties__title'>{selectedElement?.name}</div>
      <div className='mb-3'>
        <label>{label.THIS_IS_THE_ADMIN_CHIP_AND_CANNOT_BE_MODIFIED}</label>
      </div>
      <div className='row'>
        <div className='col-6'>
          <label>{label.CHIP_NAME}</label>
        </div>
        <div className='col-6'>
          <div>
            <button
              type='button'
              id='form-properties-admin-chip-show-chip-name'
              className={`form-admin-chip-properties__chip-name-btn form-admin-chip-properties__chip-name-btn--left ${
                showChipName ? "form-admin-chip-properties__chip-name-btn--active" : "form-admin-chip-properties__chip-name-btn--inactive"
              }`}
              onClick={() => onFieldPropertiesChange(selectedElement?.id, { showChipName: true })}>
              {label.SHOW}
            </button>
            <button
              type='button'
              id='form-properties-admin-chip-hide-chip-name'
              className={`form-admin-chip-properties__chip-name-btn form-admin-chip-properties__chip-name-btn--right ${
                !showChipName ? "form-admin-chip-properties__chip-name-btn--active" : "form-admin-chip-properties__chip-name-btn--inactive"
              }`}
              onClick={() => onFieldPropertiesChange(selectedElement?.id, { showChipName: false })}>
              {label.HIDE}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormAdminChipProperties;
